
const CeremonyType = (cell) => {
    return cell.value ? cell.value : '';
};
const VendorType = (cell) => {
  return cell.value ? cell.value : '';
};


const Percentage = cell => {
  return cell.value ? cell.value+'%' : "0%"
}



export { CeremonyType, Percentage, VendorType }